module.exports = __webpack_public_path__ + "img/danmachi2.9dc13321.jpg";